import { createFileRoute } from '@tanstack/react-router'
import { IncidentWorkspaceRoute } from '@/features/incidents/v2/workspace/incident-workspace-route'
import {
  parseTabSearch,
  type TabPlace,
} from '@/features/incidents/v2/workspace/tab-place'

/**
 * One route per case-workspace tab: `/incidents/<id>/overview`, `/forms`, `/tasks`,
 * `/timeline`, `/ndis`, `/evidence`, `/signoff`, and the body map page `/injuries`. The
 * static `edit` route wins over this one, and an unknown segment goes to the Overview.
 * `view` and `id` say which page of a tab is open (Add Form, one task ...), so refresh and
 * back return to it.
 */
export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/$incidentId/$tab'
)({
  // Keys only (no index signature): the place of the page, and the Compliance hub arrival.
  validateSearch: (
    raw: Record<string, unknown>
  ): TabPlace & { from?: string; obligation?: string } => {
    const place: TabPlace & { from?: string; obligation?: string } =
      parseTabSearch(raw)
    if (typeof raw.from === 'string') place.from = raw.from
    if (typeof raw.obligation === 'string') place.obligation = raw.obligation
    return place
  },
  component: IncidentWorkspaceRoute,
})
